var common = require("./common.js");

module.exports = async function(context) {
  var dashboardApi = (context || {}).dashboardApi;
  if (!(dashboardApi)) return;
  if (typeof document === "undefined") return;
  var currentDocument = document;
  var currentWindow = typeof window === "undefined" ? {} : window;
  var currentNavigator = typeof navigator === "undefined" ? {} : navigator;
  var currentFetch = typeof fetch === "function" ? fetch : null;

  function hasDomFactory() {
    return !!(currentDocument && typeof currentDocument.createElement === "function");
  }

  var dashboard = (context || {}).dashboard || {};
  var currentPage = dashboard.currentPage || {};
  var pageApiUrl = (((currentPage || {}).routes || {}).api || "").toString().trim();
  function getByIdOrData(id, attribute) {
    var node = currentDocument.getElementById(id);
    if (node) return node;
    if (attribute && typeof currentDocument.querySelector === "function") {
      return currentDocument.querySelector("[" + attribute + "]");
    }
    return null;
  }

  var passkeyList = getByIdOrData("passkey-list", "data-passkey-list");
  var passkeyResult = currentDocument.getElementById("passkey-create-result");
  var createBtn = getByIdOrData("create-passkey", "data-passkey-create-button");
  var nameInput = currentDocument.getElementById("new-passkey-name");
  var passkeyRoot = currentDocument.getElementById("platform-settings-passkeys-root");
  var passkeyCountBadge = currentDocument.getElementById("passkey-count-badge");
  var sessionsRoot = currentDocument.getElementById("platform-settings-sessions-root");
  var sessionsList = currentDocument.getElementById("sessions-list");
  var sessionsResult = currentDocument.getElementById("sessions-result");
  var sessionsCountBadge = currentDocument.getElementById("session-count-badge");
  var revokeOtherSessionsButton = currentDocument.getElementById("revoke-other-sessions");
  var panicRoot = currentDocument.getElementById("platform-auth-panic-root");
  var panicResult = currentDocument.getElementById("panic-result");
  var panicConfirmationInput = currentDocument.getElementById("panic-confirm-phrase");
  var panicSignOutButton = currentDocument.getElementById("panic-sign-out-button");
  var profileNameInput = currentDocument.getElementById("profile-name");
  var saveProfileButton = currentDocument.getElementById("save-profile-name");
  var profileResult = currentDocument.getElementById("profile-result");
  var usersResult = currentDocument.getElementById("users-result");
  var usersList = currentDocument.getElementById("users-list");
  var rolesResult = currentDocument.getElementById("roles-result");
  var rolesList = currentDocument.getElementById("roles-list");
  var addUserNameInput = currentDocument.getElementById("add-user-name");
  var addUserEmailInput = currentDocument.getElementById("add-user-email");
  var addUserRolesInput = currentDocument.getElementById("add-user-roles");
  var addUserButton = currentDocument.getElementById("add-user-button");
  var roleNamespaceInput = currentDocument.getElementById("role-namespace");
  var roleTitleInput = currentDocument.getElementById("role-title");
  var roleDescriptionInput = currentDocument.getElementById("role-description");
  var roleCanAssignInput = currentDocument.getElementById("role-canassign");
  var rolePasskeyInput = currentDocument.getElementById("role-passkey");
  var roleSaveButton = currentDocument.getElementById("role-save-button");

  function getPasskeysApiBase() {
    if (pageApiUrl) return pageApiUrl;
    if (passkeyRoot) {
      var attr = (passkeyRoot.getAttribute("data-passkeys-api-url") || "").toString().trim();
      if (attr) return attr;
    }
    return "/api/platform.settings.passkeys";
  }

  function getSessionsApiBase() {
    if (pageApiUrl) return pageApiUrl;
    if (sessionsRoot) {
      var attr = (sessionsRoot.getAttribute("data-sessions-api-url") || "").toString().trim();
      if (attr) return attr;
    }
    return "/api/platform.settings.sessions";
  }

  function getPanicApiBase() {
    if (pageApiUrl) return pageApiUrl;
    if (panicRoot) {
      var attr = (panicRoot.getAttribute("data-panic-api-url") || "").toString().trim();
      if (attr) return attr;
    }
    return "/api/platform.auth.panic";
  }

  function getErrorDescription(error, fallback) {
    if (!error) return fallback;
    return (error.description || error.message || error.title || fallback || "Something went wrong.").toString();
  }

  function getSecurityAwareErrorDescription(error, fallback) {
    var message = getErrorDescription(error, fallback);
    var namespace = (((error || {}).namespace) || "").toString().toLowerCase();
    var lowered = message.toLowerCase();
    if (namespace.indexOf('csrf') >= 0 || namespace.indexOf('session') >= 0 || lowered.indexOf('csrf') >= 0 || lowered.indexOf('origin') >= 0 || lowered.indexOf('cookie') >= 0 || lowered.indexOf('session') >= 0 || lowered.indexOf('secure') >= 0) {
      return message + ' Refresh the page to restore the secure session and CSRF state, then try again.';
    }
    return message;
  }

  function describePasskeyPolicy(row) {
    if (!row) return "Optional";
    if (row.requiresPasskey) {
      return row.hasPasskey ? "Required · Enrolled" : "Required · Missing";
    }
    return row.hasPasskey ? "Optional · Enrolled" : "Optional";
  }

  function isExactPanicConfirmation(value) {
    return (value || "").toString() === "PANIC";
  }

  function getPanicPreservationMessage(panicData) {
    var preservedCurrentSession = ((panicData || {}).preservedCurrentSession === true);
    var currentSessionPresent = ((panicData || {}).currentSessionPresent === true);

    if (preservedCurrentSession && currentSessionPresent) {
      return "Your current session stayed active.";
    }
    if (currentSessionPresent && !(preservedCurrentSession)) {
      return "Your current session did not stay active.";
    }
    return "The current-session preservation outcome could not be confirmed.";
  }

  function setPanicResultState(tone, message) {
    if (!(panicResult)) return;
    var className = "alert mb-0 py-3 px-3 small fw-semibold ";
    className += tone === "danger" ? "alert-danger" : tone === "success" ? "alert-success" : "alert-secondary";
    clearNode(panicResult);
    var state = currentDocument.createElement("div");
    state.className = className;
    state.setAttribute("role", "status");
    state.setAttribute("aria-live", "polite");
    state.textContent = (message || "").toString();
    panicResult.appendChild(state);
  }

  function clearNode(node) {
    if (!node) return;
    while (node.firstChild) node.removeChild(node.firstChild);
  }
  function renderSimpleState(container, tagName, className, message) {
    if (!container || !(hasDomFactory())) return null;
    clearNode(container);
    var node = currentDocument.createElement(tagName || "div");
    node.className = className || "";
    node.textContent = (message || "").toString();
    container.appendChild(node);
    return node;
  }

  function createCell(tagName, text, className) {
    if (!(hasDomFactory())) return null;
    var cell = currentDocument.createElement(tagName || "td");
    if (className) cell.className = className;
    cell.textContent = (text || "").toString();
    return cell;
  }

  function createTable(headers) {
    if (!(hasDomFactory())) return { table: null, tbody: null };
    var table = currentDocument.createElement("table");
    table.className = "table table-sm";
    var thead = currentDocument.createElement("thead");
    var headRow = currentDocument.createElement("tr");
    (headers || []).forEach(function(label) {
      var th = currentDocument.createElement("th");
      th.textContent = (label || "").toString();
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    table.appendChild(thead);
    var tbody = currentDocument.createElement("tbody");
    table.appendChild(tbody);
    return { table: table, tbody: tbody };
  }

  function resetSelectOptions(select) {
    if (!select) return;
    clearNode(select);
  }

  function updatePasskeyCount(count) {
    if (!passkeyCountBadge) return;
    if (typeof count === "string") {
      passkeyCountBadge.textContent = count;
      return;
    }
    var total = Number(count || 0);
    passkeyCountBadge.textContent = total === 1 ? "1 passkey" : total + " passkeys";
  }

  function renderPasskeyState(message, className) {
    if (!(passkeyList) || !(hasDomFactory())) return;
    clearNode(passkeyList);
    var state = currentDocument.createElement("div");
    state.className = className || "text-muted";
    state.textContent = message || "";
    passkeyList.appendChild(state);
  }

  function renderPasskeyEmptyState() {
    if (!(passkeyList) || !(hasDomFactory())) return;
    clearNode(passkeyList);
    var wrap = currentDocument.createElement("div");
    wrap.className = "border rounded-3 p-3 bg-light-subtle text-muted";
    var title = currentDocument.createElement("div");
    title.className = "fw-semibold text-body mb-1";
    title.textContent = "No passkeys yet";
    var copy = currentDocument.createElement("div");
    copy.className = "small";
    copy.textContent = "Create your first passkey on this device to speed up future sign in.";
    wrap.appendChild(title);
    wrap.appendChild(copy);
    passkeyList.appendChild(wrap);
  }

  function getPasskeyDisplayName(row) {
    return (((row || {}).name) || "Passkey").toString();
  }

  function getPasskeyIdentifier(row) {
    return (((row || {}).id) || "").toString().trim();
  }

  function getPasskeyDeletePayload(row) {
    return {
      id: getPasskeyIdentifier(row)
    };
  }

  function getCreatePasskeyLabel(button) {
    if (!(button)) return "Create Passkey";
    return (button.getAttribute("data-default-label") || button.textContent || "Create Passkey").toString().trim() || "Create Passkey";
  }

  function renderButtonContent(button, iconClass, label) {
    if (!(button) || !(hasDomFactory())) {
      if (button) button.textContent = (label || "").toString();
      return;
    }
    clearNode(button);

    var icon = (iconClass || "").toString().trim();
    if (icon) {
      var iconNode = currentDocument.createElement("i");
      iconNode.className = icon;
      button.appendChild(iconNode);
    }

    if (typeof currentDocument.createTextNode === "function") {
      button.appendChild(currentDocument.createTextNode((label || "").toString()));
    } else {
      button.textContent = (label || "").toString();
    }
  }

  function setCreatePasskeyBusy(isBusy) {
    if (!(createBtn)) return;
    createBtn.disabled = isBusy === true;
    if (isBusy) {
      createBtn.setAttribute("aria-busy", "true");
      renderButtonContent(createBtn, "", "Creating Passkey…");
      return;
    }

    createBtn.removeAttribute("aria-busy");
    renderButtonContent(createBtn, createBtn.getAttribute("data-default-icon-class") || "", getCreatePasskeyLabel(createBtn));
  }

  function setPasskeyCreateRecoveryMessage(message, tone) {
    var className = tone === "danger" ? "text-danger" : tone === "success" ? "text-success" : "text-muted";
    common.setSmallResult(passkeyResult, className, (message || "").toString());
  }

  function classifyPasskeyCreateError(error, fallback) {
    var namespace = (((error || {}).namespace) || "").toString().toLowerCase();
    var name = (((error || {}).name) || "").toString();
    var rawMessage = getErrorDescription(error, fallback || "Unable to finish passkey setup.");
    var lowered = rawMessage.toLowerCase();

    if (name === "NotAllowedError") {
      return "Passkey setup was canceled or dismissed. Nothing was saved. You can try again whenever you are ready.";
    }
    if (name === "AbortError") {
      return "Passkey setup was interrupted before it finished. Nothing was saved. You can try again on this page.";
    }
    if (name === "NotSupportedError") {
      return "This browser or device cannot create passkeys here. Try again on a passkey-capable browser or device.";
    }
    if (namespace.indexOf('csrf') >= 0 || namespace.indexOf('session') >= 0 || lowered.indexOf('csrf') >= 0 || lowered.indexOf('cookie') >= 0 || lowered.indexOf('secure') >= 0) {
      return "Passkey setup could not continue because the secure session was rejected. Refresh the page, then try again.";
    }
    if (lowered.indexOf('relying party') >= 0 || lowered.indexOf('rp id') >= 0 || lowered.indexOf('domain') >= 0 || lowered.indexOf('origin') >= 0) {
      return "This passkey cannot be created from the current site address. Open the app from its normal secure address, then try again.";
    }

    return "Passkey setup could not finish. Nothing was saved. Try again on this page, or refresh first if the problem keeps happening.";
  }

  function getPasskeySavedNameText(row) {
    return 'Saved as "' + getPasskeyDisplayName(row) + '"';
  }

  function getPasskeyDiscriminator(row) {
    var idHint = getPasskeyIdentifier(row);
    if (idHint) {
      return "ID …" + idHint.slice(-8);
    }

    var createdOn = common.accountingToIso(((row || {}).createdOn) || "");
    if (createdOn) {
      return "added " + createdOn;
    }

    return "selected entry";
  }

  function buildPasskeyRemovalPrompt(row) {
    return "Remove passkey \"" + getPasskeyDisplayName(row) + "\" (" + getPasskeyDiscriminator(row) + ") from your account?";
  }

  function renderPasskeyRows(rows) {
    if (!(passkeyList) || !(hasDomFactory())) return;
    clearNode(passkeyList);

    var list = currentDocument.createElement("div");
    list.className = "list-group list-group-flush";

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i] || {};
      var item = currentDocument.createElement("div");
      item.className = "list-group-item px-0 d-flex justify-content-between align-items-start gap-3";

      var meta = currentDocument.createElement("div");
      meta.className = "min-w-0";

      var title = currentDocument.createElement("div");
      title.className = "fw-semibold text-break";
      title.textContent = getPasskeyDisplayName(row);

      var details = currentDocument.createElement("div");
      details.className = "small text-muted d-flex flex-column gap-1 mt-1";

      var discriminator = currentDocument.createElement("div");
      discriminator.textContent = getPasskeyDiscriminator(row);
      details.appendChild(discriminator);

      var created = currentDocument.createElement("div");
      created.textContent = "Added " + (common.accountingToIso(row.createdOn || "") || "recently");
      details.appendChild(created);

      if ((row.lastUsedOn || "").toString().trim()) {
        var used = currentDocument.createElement("div");
        used.textContent = "Last used " + (common.accountingToIso(row.lastUsedOn || "") || "recently");
        details.appendChild(used);
      }

      meta.appendChild(title);
      meta.appendChild(details);

      var actions = currentDocument.createElement("div");
      actions.className = "d-flex align-items-center gap-2 flex-shrink-0";

      var removeButton = currentDocument.createElement("button");
      removeButton.type = "button";
      removeButton.className = "btn btn-sm btn-outline-danger";
      removeButton.textContent = "Remove";
      removeButton.addEventListener("click", async function(rowData, button) {
        if (!currentWindow.confirm(buildPasskeyRemovalPrompt(rowData))) return;
        button.disabled = true;
        try {
          await dashboardApi.withBase(getPasskeysApiBase()).action("delete", getPasskeyDeletePayload(rowData));
          common.setSmallResult(passkeyResult, "text-success", getPasskeySavedNameText(rowData) + " removed.");
          await reloadPasskeys();
        } catch (error) {
          common.setSmallResult(passkeyResult, "text-danger", getSecurityAwareErrorDescription(error, "Unable to remove passkey."));
          button.disabled = false;
        }
      }.bind(null, row, removeButton));

      actions.appendChild(removeButton);
      item.appendChild(meta);
      item.appendChild(actions);
      list.appendChild(item);
    }

    passkeyList.appendChild(list);
  }

  function updateSessionCount(count) {
    if (!sessionsCountBadge) return;
    var total = Number(count || 0);
    sessionsCountBadge.textContent = total === 1 ? "1 session" : total + " sessions";
  }

  function getSessionLoginRedirect(response) {
    var payload = (response && response.data) || {};
    var loginUrl = (payload.loginUrl || payload.redirectUrl || "").toString().trim();
    if (loginUrl) return loginUrl;
    return "/auth/login?redirect=" + encodeURIComponent(currentWindow.location.pathname || "/dashboard");
  }

  function renderSessionsState(message, className) {
    if (!(sessionsList) || !(hasDomFactory())) return;
    clearNode(sessionsList);
    var state = currentDocument.createElement("div");
    state.className = className || "text-muted";
    state.textContent = message || "";
    sessionsList.appendChild(state);
  }

  function describeSessionFactors(row) {
    var factors = [];
    if (((row || {}).authFactors || {}).emailCode) factors.push("Email code");
    if (((row || {}).authFactors || {}).passkey) factors.push("Passkey");
    if (factors.length === 0) factors.push("Unknown");
    return factors.join(" + ");
  }

  function renderSessionRows(rows) {
    if (!(sessionsList)) return;
    clearNode(sessionsList);

    var list = currentDocument.createElement("div");
    list.className = "d-flex flex-column gap-3";

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i] || {};
      var card = currentDocument.createElement("div");
      card.className = "border rounded-3 p-3" + (row.current ? " border-success-subtle bg-success-subtle" : " bg-body-tertiary");

      var top = currentDocument.createElement("div");
      top.className = "d-flex flex-column flex-lg-row justify-content-between align-items-lg-start gap-3";

      var meta = currentDocument.createElement("div");
      meta.className = "min-w-0";

      var heading = currentDocument.createElement("div");
      heading.className = "d-flex flex-wrap align-items-center gap-2 mb-2";

      var title = currentDocument.createElement("div");
      title.className = "fw-semibold text-break";
      title.textContent = row.current ? "Current session" : "Active session";
      heading.appendChild(title);

      if (row.current) {
        var currentBadge = currentDocument.createElement("span");
        currentBadge.className = "badge text-bg-success";
        currentBadge.textContent = "This device";
        heading.appendChild(currentBadge);
      }

      if (row.expiresSoon) {
        var expiryBadge = currentDocument.createElement("span");
        expiryBadge.className = "badge text-bg-warning";
        expiryBadge.textContent = "Expires soon";
        heading.appendChild(expiryBadge);
      }

      var details = currentDocument.createElement("div");
      details.className = "small text-muted d-flex flex-column gap-1";

      var created = currentDocument.createElement("div");
      created.textContent = "Started " + (common.accountingToIso(row.createdOn || "") || "recently");
      details.appendChild(created);

      var tokenHint = currentDocument.createElement("div");
      tokenHint.textContent = "Session ID …" + ((row.id || "").toString().slice(-8) || "unknown");
      details.appendChild(tokenHint);

      var factors = currentDocument.createElement("div");
      factors.textContent = "Sign-in factors: " + describeSessionFactors(row);
      details.appendChild(factors);

      var providerLine = currentDocument.createElement("div");
      providerLine.textContent = "Provider: " + ((row.provider || "local").toString());
      details.appendChild(providerLine);

      if (row.enrollmentRequiredPasskey) {
        var enrollment = currentDocument.createElement("div");
        enrollment.textContent = "Passkey enrollment is still required for this account.";
        details.appendChild(enrollment);
      }

      meta.appendChild(heading);
      meta.appendChild(details);

      var actions = currentDocument.createElement("div");
      actions.className = "d-flex align-items-center gap-2 flex-shrink-0";

      var revokeButton = currentDocument.createElement("button");
      revokeButton.type = "button";
      revokeButton.className = row.current ? "btn btn-sm btn-danger" : "btn btn-sm btn-outline-danger";
      revokeButton.textContent = row.current ? "Sign out" : "Revoke";
      revokeButton.addEventListener("click", async function(sessionId, isCurrent, button) {
        var prompt = isCurrent
          ? "Sign out of your current dashboard session?"
          : "Revoke this active session?";
        if (!currentWindow.confirm(prompt)) return;
        button.disabled = true;
        try {
          var response = await dashboardApi.withBase(getSessionsApiBase()).action("revoke", { token: sessionId });
          if (isCurrent) {
            currentWindow.location.href = getSessionLoginRedirect(response);
            return;
          }
          common.setSmallResult(sessionsResult, "text-success", "Session revoked.");
          await reloadSessions();
        } catch (error) {
          common.setSmallResult(sessionsResult, "text-danger", getErrorDescription(error, "Unable to revoke session."));
          button.disabled = false;
        }
      }.bind(null, row.id, row.current === true, revokeButton));

      actions.appendChild(revokeButton);
      top.appendChild(meta);
      top.appendChild(actions);
      card.appendChild(top);
      list.appendChild(card);
    }

    sessionsList.appendChild(list);
  }

  async function reloadSessions() {
    if (!(sessionsList)) return;
    updateSessionCount(0);
    renderSessionsState("Loading sessions…", "text-muted small");

    try {
      var response = await dashboardApi.withBase(getSessionsApiBase()).action("list", {});
      var payload = (response && response.data) || {};
      var rows = payload.rows || payload || [];

      if (!(rows instanceof Array) || rows.length === 0) {
        updateSessionCount(0);
        renderSessionsState("No active sessions were found.", "border rounded-3 p-3 bg-light-subtle text-muted");
        if (revokeOtherSessionsButton) revokeOtherSessionsButton.disabled = true;
        return;
      }

      updateSessionCount(rows.length);
      renderSessionRows(rows);

      var hasCurrentSession = rows.some(function(row) {
        return row && row.current === true;
      });
      var otherSessionsCount = rows.filter(function(row) {
        return row && row.current !== true;
      }).length;

      if (revokeOtherSessionsButton) {
        revokeOtherSessionsButton.disabled = hasCurrentSession !== true || otherSessionsCount === 0;
      }

      if (!(hasCurrentSession)) {
        common.setSmallResult(sessionsResult, "text-warning", "Your current session was not returned, so signing out other sessions is disabled until the session list is complete.");
      } else {
        common.setSmallResult(sessionsResult, "text-muted", "");
      }
    } catch (error) {
      updateSessionCount(0);
      renderSessionsState(getErrorDescription(error, "Unable to load sessions."), "alert alert-danger mb-0");
      if (revokeOtherSessionsButton) revokeOtherSessionsButton.disabled = true;
    }
  }

  async function reloadPasskeys() {
    if (!(passkeyList)) return;
    updatePasskeyCount("...");
    renderPasskeyState("Loading passkeys…", "text-muted small");

    try {
      var response = await dashboardApi.withBase(getPasskeysApiBase()).action("list", {});
      var payload = (response && response.data) || {};
      var rows = payload.rows || payload || [];

      if (!(rows instanceof Array) || rows.length === 0) {
        updatePasskeyCount(0);
        renderPasskeyEmptyState();
        return;
      }

      updatePasskeyCount(rows.length);
      renderPasskeyRows(rows);
    } catch (error) {
      updatePasskeyCount(0);
      renderPasskeyState(getSecurityAwareErrorDescription(error, "Unable to load passkeys."), "alert alert-danger mb-0");
    }
  }

  async function reloadRoleDefinitions() {
    if (!(rolesList) && !(addUserRolesInput)) return [];
    var response = await currentFetch("/auth/role-definition/list");
    var json = await response.json();
    if (!(response.ok) || !(json.success)) {
      if (rolesList) renderSimpleState(rolesList, "div", "alert alert-danger mb-0", "Unable to load role definitions.");
      return [];
    }

    var rows = json.data || [];
    resetSelectOptions(addUserRolesInput);
    var roleTable = rolesList ? createTable(["Namespace", "Title", "Passkey", "Actions"]) : null;

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i] || {};
      var namespace = (row.namespace || "");
      var isSystemRole = (namespace.indexOf(".") < 0) || (namespace.indexOf("admin.app") === 0) || (namespace.indexOf("superadmin.universe") === 0);
      var option = currentDocument.createElement("option");
      option.value = namespace;
      option.textContent = namespace;
      if (addUserRolesInput) addUserRolesInput.appendChild(option);
      if (roleTable) {
        var tr = currentDocument.createElement("tr");
        tr.appendChild(createCell("td", namespace));
        tr.appendChild(createCell("td", row.title || ""));
        tr.appendChild(createCell("td", row.requiresPasskey ? "Yes" : "No"));
        var actionsCell = currentDocument.createElement("td");
        if (!(isSystemRole)) {
          var deleteButton = currentDocument.createElement("button");
          deleteButton.type = "button";
          deleteButton.className = "btn btn-sm btn-outline-danger role-delete";
          deleteButton.setAttribute("data-role-namespace", namespace);
          deleteButton.textContent = "Delete";
          actionsCell.appendChild(deleteButton);
        } else {
          var systemText = currentDocument.createElement("span");
          systemText.className = "text-muted small";
          systemText.textContent = "System";
          actionsCell.appendChild(systemText);
        }
        tr.appendChild(actionsCell);
        roleTable.tbody.appendChild(tr);
      }
    }

    if (rolesList) {
      clearNode(rolesList);
      rolesList.appendChild(roleTable.table);
    }

    if (!(rolesList)) return rows;

    var roleDeleteButtons = rolesList.querySelectorAll("button.role-delete");
    for (var j = 0; j < roleDeleteButtons.length; j++) {
      roleDeleteButtons[j].addEventListener("click", async function() {
        var ns = this.getAttribute("data-role-namespace") || "";
        var repo = await currentFetch("/auth/role-definition/delete", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ namespace: ns })
        });
        var body = await repo.json();
        if (!(repo.ok) || !(body.success)) {
          common.setSmallResult(rolesResult, "text-danger", "Unable to delete role.");
          return;
        }
        common.setSmallResult(rolesResult, "text-success", "Role deleted.");
        await reloadRoleDefinitions();
        await reloadUsers();
      });
    }

    return rows;
  }

  async function reloadUsers() {
    if (!(usersList)) return;
    var response = await currentFetch("/auth/users/list");
    var json = {};
    try {
      json = await response.json();
    } catch (error) {
      json = {};
    }
    if (!(response.ok) || !(json.success)) {
      var errorObject = (((json || {}).errors || [])[0]) || {};
      var errorDescription = (errorObject.description || errorObject.message || errorObject.title || "").toString().trim();
      if (!(errorDescription)) {
        errorDescription = "Unable to load users.";
      }
      renderSimpleState(usersList, "div", "alert alert-danger mb-0", errorDescription);
      return;
    }

    var rows = json.data || [];
    if (!(rows instanceof Array) || rows.length === 0) {
      renderSimpleState(usersList, "p", "m-0", "No users found.");
      return;
    }

    var userTable = createTable(["Name", "Email", "Roles", "Passkey Policy", "Status", "Actions"]);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i] || {};
      var roleText = ((row.roles || []).join(", "));
      var lockedSuperadmin = ((row.roles || []).indexOf("superadmin.universe") >= 0);
      var tr = currentDocument.createElement("tr");
      tr.appendChild(createCell("td", (row.name || "").toString() || "-"));
      tr.appendChild(createCell("td", row.email || ""));
      var rolesCell = currentDocument.createElement("td");
      var rolesInputNode = currentDocument.createElement("input");
      rolesInputNode.className = "form-control form-control-sm user-roles";
      rolesInputNode.setAttribute("data-user-email", (row.email || "").toString());
      rolesInputNode.value = roleText;
      rolesCell.appendChild(rolesInputNode);
      tr.appendChild(rolesCell);
      tr.appendChild(createCell("td", describePasskeyPolicy(row)));
      tr.appendChild(createCell("td", row.exists ? "Registered" : "Invited"));
      var actionsCell = currentDocument.createElement("td");
      actionsCell.className = "d-flex gap-1";
      var saveButton = currentDocument.createElement("button");
      saveButton.type = "button";
      saveButton.className = "btn btn-sm btn-outline-primary user-save";
      saveButton.setAttribute("data-user-email", (row.email || "").toString());
      saveButton.textContent = "Save";
      actionsCell.appendChild(saveButton);
      if (!(lockedSuperadmin)) {
        var removeButton = currentDocument.createElement("button");
        removeButton.type = "button";
        removeButton.className = "btn btn-sm btn-outline-danger user-remove";
        removeButton.setAttribute("data-user-email", (row.email || "").toString());
        removeButton.textContent = "Remove";
        actionsCell.appendChild(removeButton);
      } else {
        var protectedText = currentDocument.createElement("span");
        protectedText.className = "text-muted small";
        protectedText.textContent = "Protected";
        actionsCell.appendChild(protectedText);
      }
      tr.appendChild(actionsCell);
      userTable.tbody.appendChild(tr);
    }
    clearNode(usersList);
    usersList.appendChild(userTable.table);

    var saveButtons = usersList.querySelectorAll("button.user-save");
    for (var s = 0; s < saveButtons.length; s++) {
      saveButtons[s].addEventListener("click", async function() {
        var email = this.getAttribute("data-user-email") || "";
        var rowElement = this.closest("tr");
        var rolesInput = rowElement ? rowElement.querySelector("input.user-roles") : null;
        var roleList = ((rolesInput && rolesInput.value) || "").split(",").map(function(item) {
          return item.trim();
        }).filter(Boolean);

        var repo = await currentFetch("/auth/access/add", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: email,
            roles: roleList
          })
        });
        var body = await repo.json();
        if (!(repo.ok) || !(body.success)) {
          common.setSmallResult(usersResult, "text-danger", "Failed to update user roles.");
          return;
        }
        common.setSmallResult(usersResult, "text-success", "User roles updated.");
        await reloadUsers();
      });
    }

    var removeButtons = usersList.querySelectorAll("button.user-remove");
    for (var r = 0; r < removeButtons.length; r++) {
      removeButtons[r].addEventListener("click", async function() {
        var email = this.getAttribute("data-user-email") || "";
        var repo = await currentFetch("/auth/access/remove", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email })
        });
        var body = await repo.json();
        if (!(repo.ok) || !(body.success)) {
          common.setSmallResult(usersResult, "text-danger", "Unable to remove access.");
          return;
        }
        common.setSmallResult(usersResult, "text-success", "Access removed.");
        await reloadUsers();
      });
    }
  }

  if (revokeOtherSessionsButton) {
    revokeOtherSessionsButton.addEventListener("click", async function() {
      if (!currentWindow.confirm("Sign out every other active session and keep this one?")) return;
      revokeOtherSessionsButton.disabled = true;
      common.setSmallResult(sessionsResult, "text-muted", "");
      try {
        var response = await dashboardApi.withBase(getSessionsApiBase()).action("revoke", { revokeOthers: true });
        var revoked = Number((((response || {}).data) || {}).revoked || 0);
        if (revoked > 0) {
          common.setSmallResult(sessionsResult, "text-success", revoked === 1 ? "1 other session signed out." : revoked + " other sessions signed out.");
        } else {
          common.setSmallResult(sessionsResult, "text-muted", "No other sessions were active.");
        }
        await reloadSessions();
      } catch (error) {
        common.setSmallResult(sessionsResult, "text-danger", getErrorDescription(error, "Unable to sign out other sessions."));
        revokeOtherSessionsButton.disabled = false;
      }
    });
  }

  if (panicConfirmationInput && panicSignOutButton) {
    panicConfirmationInput.addEventListener("input", function() {
      panicSignOutButton.disabled = !(isExactPanicConfirmation(panicConfirmationInput.value));
    });

    panicSignOutButton.addEventListener("click", async function() {
      var typed = (panicConfirmationInput.value || "").toString();
      if (!(isExactPanicConfirmation(typed))) {
        setPanicResultState("danger", "Type PANIC exactly before using the emergency control.");
        panicSignOutButton.disabled = true;
        return;
      }
      if (!currentWindow.confirm("Emergency action: sign out every other active dashboard session across the platform?")) return;

      panicSignOutButton.disabled = true;
      panicSignOutButton.setAttribute("aria-busy", "true");
      setPanicResultState("muted", "Running panic sign-out…");

      try {
        var panicResponse = await dashboardApi.withBase(getPanicApiBase()).action("execute", { confirmation: typed });
        var panicData = (panicResponse && panicResponse.data) || {};
        var revokedSessions = Number(panicData.revoked || 0);
        var affectedAccountCount = Number(panicData.affectedAccountCount || 0);
        var summary = revokedSessions === 1
          ? "1 other session signed out"
          : revokedSessions + " other sessions signed out";
        if (affectedAccountCount > 0) {
          summary += " across " + affectedAccountCount + (affectedAccountCount === 1 ? " account." : " accounts.");
        } else {
          summary += "; no affected accounts were reported.";
        }
        setPanicResultState("success", summary + " " + getPanicPreservationMessage(panicData));
        panicConfirmationInput.value = "";
        panicSignOutButton.disabled = true;
      } catch (error) {
        setPanicResultState("danger", getErrorDescription(error, "Unable to complete panic sign-out."));
        panicSignOutButton.disabled = !(isExactPanicConfirmation(panicConfirmationInput.value));
      } finally {
        panicSignOutButton.removeAttribute("aria-busy");
      }
    });
  }

  async function createPasskey() {
    setPasskeyCreateRecoveryMessage("Preparing your device for passkey setup… If the device prompt does not appear or you change your mind, you can safely try again.", "muted");

    if (!(currentWindow.PublicKeyCredential && currentNavigator.credentials && typeof currentNavigator.credentials.create === "function")) {
      common.setSmallResult(passkeyResult, "text-danger", "Passkeys are not supported in this browser.");
      return;
    }

    var name = (nameInput.value || "").trim();
    setCreatePasskeyBusy(true);

    try {
      var optionsResponse = await dashboardApi.withBase(getPasskeysApiBase()).action("registeroptions", { name: name });
      var options = (optionsResponse && optionsResponse.data) || {};
      var publicKey = {
        challenge: common.fromBase64Url(options.challenge || ""),
        rp: options.rp || undefined,
        user: {
          id: common.fromBase64Url((((options || {}).user || {}).id || "")),
          name: (((options || {}).user || {}).name || ""),
          displayName: (((options || {}).user || {}).displayName || "")
        },
        pubKeyCredParams: options.pubKeyCredParams || [{ type: "public-key", alg: -7 }],
        timeout: options.timeout || 60000,
        attestation: options.attestation || "none",
        authenticatorSelection: options.authenticatorSelection || { userVerification: "preferred" }
      };

      var credential = await currentNavigator.credentials.create({ publicKey: publicKey });
      if (!(credential)) {
        setPasskeyCreateRecoveryMessage("Passkey setup did not finish, and nothing was saved. You can try again on this page.", "danger");
        return;
      }

      var verifyResponse = await dashboardApi.withBase(getPasskeysApiBase()).action("registerverify", {
        name: name,
        challenge: options.challenge,
        id: credential.id,
        rawId: common.toBase64Url(new Uint8Array(credential.rawId)),
        type: credential.type,
        response: {
          clientDataJSON: common.toBase64Url(new Uint8Array(credential.response.clientDataJSON)),
          attestationObject: common.toBase64Url(new Uint8Array(credential.response.attestationObject))
        }
      });

      var savedPasskey = ((verifyResponse || {}).data || {}).passkey || {};
      setPasskeyCreateRecoveryMessage("Passkey added to your account. Saved as \"" + getPasskeyDisplayName(savedPasskey) + "\".", "success");
      nameInput.value = "";
      await reloadPasskeys();
    } catch (error) {
      var message = classifyPasskeyCreateError(error, "Unable to finish passkey setup.");
      setPasskeyCreateRecoveryMessage(message, "danger");
    } finally {
      setCreatePasskeyBusy(false);
    }
  }

  if (createBtn && passkeyResult && nameInput) {
    createBtn.addEventListener("click", createPasskey);
    nameInput.addEventListener("keydown", async function(event) {
      if ((event.key || "") !== "Enter") return;
      event.preventDefault();
      await createPasskey();
    });
  }

  if (profileNameInput) {
    profileNameInput.value = ((((dashboard.user || {}).name) || "") + "");
  }

  if (saveProfileButton && profileNameInput) {
    saveProfileButton.addEventListener("click", async function() {
      var repo = await currentFetch("/auth/profile/update", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: (profileNameInput.value || "").trim() })
      });
      var body = {};
      try {
        body = await repo.json();
      } catch (error) {
        body = {};
      }
      if (!(repo.ok) || !(body.success)) {
        var errorObject = (((body || {}).errors || [])[0]) || {};
        var errorDescription = (errorObject.description || errorObject.message || errorObject.title || "").toString().trim();
        if (!(errorDescription)) {
          errorDescription = "Unable to save profile name.";
        }
        common.setSmallResult(profileResult, "text-danger", errorDescription);
        return;
      }
      common.setSmallResult(profileResult, "text-success", "Profile updated.");
      currentWindow.location.reload();
    });
  }

  if (addUserButton && addUserEmailInput && addUserNameInput && addUserRolesInput) {
    addUserButton.addEventListener("click", async function() {
      var payload = {
        name: (addUserNameInput.value || "").trim(),
        email: (addUserEmailInput.value || "").trim(),
        roles: common.getSelectedValues(addUserRolesInput)
      };
      var repo = await currentFetch("/auth/access/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      var body = await repo.json();
      if (!(repo.ok) || !(body.success)) {
        common.setSmallResult(usersResult, "text-danger", "Unable to add/update user.");
        return;
      }
      common.setSmallResult(usersResult, "text-success", "User access saved.");
      addUserEmailInput.value = "";
      addUserNameInput.value = "";
      await reloadUsers();
    });
  }

  if (roleSaveButton && roleNamespaceInput && roleTitleInput && roleDescriptionInput && roleCanAssignInput) {
    roleSaveButton.addEventListener("click", async function() {
      var payload = {
        definition: {
          namespace: (roleNamespaceInput.value || "").trim().toLowerCase(),
          title: (roleTitleInput.value || "").trim(),
          description: (roleDescriptionInput.value || "").trim(),
          canAssign: (roleCanAssignInput.value || "").split(",").map(function(item) { return item.trim().toLowerCase(); }).filter(Boolean),
          requiresPasskey: !!(rolePasskeyInput && rolePasskeyInput.checked)
        }
      };
      var repo = await currentFetch("/auth/role-definition/upsert", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      var body = await repo.json();
      if (!(repo.ok) || !(body.success)) {
        common.setSmallResult(rolesResult, "text-danger", "Unable to save role.");
        return;
      }
      common.setSmallResult(rolesResult, "text-success", "Role saved.");
      await reloadRoleDefinitions();
      await reloadUsers();
    });
  }

  if (passkeyList) await reloadPasskeys();
  if (sessionsList) await reloadSessions();
  if (rolesList || addUserRolesInput) await reloadRoleDefinitions();
  if (usersList) await reloadUsers();
};
